// ABOUTME: Context and hook for toast notifications across the application
// ABOUTME: The provider (and the Toaster) lives in NotificationProvider.tsx; this file has no components

import { createContext, useContext } from "react"

export type ToastType = "success" | "error"

export interface ToastMessage {
  type: ToastType
  message: string
  isLoading: boolean
  timeout: number
}

export interface NotificationContextProps {
  handleNotification: (type: ToastType, message: string, loading: boolean, timeout: number) => void
}

export const NotificationContext = createContext<NotificationContextProps | undefined>(undefined)

export const useNotificationContext = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    // Return no-op fallback for error boundary recovery or HMR edge cases
    return { handleNotification: () => {} }
  }
  return context
}

export default NotificationContext
